import { Box, Typography } from '@mui/material';
import classes from './Benefits.module.scss';
import BenefitsStack from './BenefitsStack/BenefitsStack';
import { Calendar, Doctor, Patient, Pharmacy } from '@src/illustrations';
const benefits = [{
  icon: <Doctor />,
  title: 'Walk-ins welcome',
  description: 'No visit required'
}, {
  icon: <Calendar />,
  title: 'Open 7 days/week',
  description: 'including holidays'
}, {
  icon: <Patient />,
  title: '24/7 virtual care',
  description: 'wherever, whenever'
}, {
  icon: <Pharmacy />,
  title: 'Flexible insurance',
  description: 'flat uninsured rate'
}];
export default function Benefits() {
  return <Box className={classes['benefits-container']} data-sentry-element="Box" data-sentry-component="Benefits" data-sentry-source-file="Benefits.tsx">
			<Typography variant="benefitsTitle" color="primary.700" data-sentry-element="Typography" data-sentry-source-file="Benefits.tsx">
				Get better, faster, with healthcare on your terms
			</Typography>
			<Box className={classes['benefits-stack']} data-sentry-element="Box" data-sentry-source-file="Benefits.tsx">
				{benefits.map((benefit, index) => <BenefitsStack key={index} benefit={benefit} />)}
			</Box>
		</Box>;
}